"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RatingBase = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _i18n = require("../../../i18n/i18n");
var _visuallyhidden = require("../../visuallyhidden");
var _RatingOption = require("../components/RatingOption");
var _RatingStyled = require("../styled/RatingStyled");
const RatingBase = /*#__PURE__*/(0, _react.forwardRef)((_ref, forwardedRef) => {
  let {
    clientId,
    id: providedId,
    omitSelectedTooltip = false,
    isDisabled = false,
    isReadonly = false,
    value,
    maxValue = 5,
    name: providedName,
    onChange,
    renderActive,
    renderHovered,
    renderInactive,
    ...rest
  } = _ref;
  if (process.env.NODE_ENV !== "production") {
    if (maxValue < 1) {
      console.warn(`Rating: maxValue ${maxValue} cannot be less than 1.`);
    }
    if (value < 0) {
      console.warn(`Rating: value ${value} cannot be less than 0.`);
    }
    if (value > maxValue) {
      console.warn(`Rating: value ${value} cannot be greater than the maxValue: ${maxValue}`);
    }
    if (isDisabled) {
      console.warn("Rating: isDisabled is deprecated. Please use isReadonly instead.");
    }
  }
  const {
    i18n
  } = (0, _i18n.useI18n)();
  const [liveRegion, setLiveRegion] = (0, _react.useState)("");
  const [hoveredIndex, setHoveredIndex] = (0, _react.useState)(0);
  const name = (0, _react.useMemo)(() => providedName || (0, _lodestarUtils.genId)("rating-radio-group-"), [providedName]);
  const id = (0, _react.useMemo)(() => providedId || (0, _lodestarUtils.genId)("rating-radio-group-"), [providedId]);
  const handleOptionSelected = (0, _react.useCallback)(newValue => {
    const shouldReset = value === newValue;
    onChange(shouldReset ? 0 : newValue);
    if (shouldReset) {
      setLiveRegion(i18n._({
        comment: "screen readers read this when they click or press enter/space to clear a rating selection",
        id: "selection cleared"
      }));
    } else {
      setLiveRegion("");
    }
  }, [value, i18n, onChange]);

  /**
   * Callback for when a RatingOption is hovered. Controls the intermediate display state.
   * @param value - Value/Index of the RatingOption
   * @param isHovered - Boolean to discriminate between hovering on and off
   */
  const handleOptionHovered = (0, _react.useCallback)((hoveredValue, isHovered) => {
    if (isHovered && !isDisabled && !isReadonly) {
      setHoveredIndex(hoveredValue);
    }
  }, [isDisabled, isReadonly]);

  /**
   * This array will be mapped to produce the rating elements.
   * It contains 1..maxValue
   */
  const mappableListing = (0, _react.useMemo)(() => Array.from({
    length: maxValue
  }, (_, i) => i + 1), [maxValue]);

  // Cap out at the maxValue.
  // This is to protect internal function, not to correct improper values provided
  const selectedValue = Math.min(value, maxValue);
  return /*#__PURE__*/_react.default.createElement(_RatingStyled.RatingStyled, (0, _extends2.default)({
    "data-client-id": clientId,
    ref: forwardedRef,
    role: "radiogroup",
    onMouseLeave: () => {
      setHoveredIndex(-1);
    },
    "aria-label": i18n._( /* i18n */{
      comment: "Label for a rating group e.g. a component that allows users to pick the number of stars out of 5",
      id: "Choose a rating"
    })
  }, rest), mappableListing.map(ratingValue => {
    // Determine the current state of this option
    const activeState = hoveredIndex > selectedValue ? ratingValue <= hoveredIndex ? ratingValue <= selectedValue ? "active" : "hovered" : "inactive" : ratingValue <= selectedValue ? "active" : "inactive";

    // Determine which child render function should be called
    const renderChild = {
      active: renderActive,
      hovered: renderHovered,
      inactive: renderInactive
    }[activeState];
    return /*#__PURE__*/_react.default.createElement(_RatingOption.RatingOption, {
      clientId: clientId,
      groupId: id,
      isDisabled: isDisabled,
      isReadonly: isReadonly,
      omitSelectedTooltip: omitSelectedTooltip,
      isSelected: ratingValue === selectedValue,
      key: ratingValue,
      onHover: handleOptionHovered,
      onClick: handleOptionSelected,
      value: ratingValue,
      name: name
    }, renderChild(ratingValue));
  }), /*#__PURE__*/_react.default.createElement(_visuallyhidden.VisuallyHidden, {
    "aria-live": "polite"
  }, liveRegion));
});
exports.RatingBase = RatingBase;
RatingBase.displayName = "RatingBase";
//# sourceMappingURL=RatingBase.js.map